<div class="game-status-banner" [ngClass]="['game-status-banner--theme-' + data.colorTheme]" brtBorderGradient [color]="borderGradientColor">
  <div class="game-status-banner__headline">
    <brt-dashboard-boxes-head [data]="data.headlineData"></brt-dashboard-boxes-head>
  </div>

  <div class="game-status-banner__content">
    <div class="game-status-banner__content-text">
      <span [innerHTML]="data.content" brtRoughText [type]="'highlight'" [color]="StoryTheme.WHITE" [state]="'run'" [selector]="'em'" [iterations]="2"></span>
      <a [routerLink]="data.link.url" class="game-status-banner__link" *ngIf="data.link"><brt-button [size]="'small'" [title]="data.link.title" [color]="'white'"></brt-button></a>
    </div>

  </div>
</div>
